import {
    Card,
    CardMedia,
    Container,
    Typography,
    styled,
  } from "@mui/material";
  import { useTranslation } from "react-i18next";
  import AccessoryDetails from "../Assets/AccessoryDetails.png";
import { HeaderCard } from "../Components/Cards/MainCard";
import { useEffect } from "react";

  const AccessoriessGuide: React.FC = () => {
    const { t } = useTranslation();
  
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    const CustomCard = styled(Card)({
      borderRadius: 10,
      marginBottom: "12px",
      backgroundColor: "whitesmoke",
      padding: "20px"
    });
  
    const CustomTypography = styled(Typography)({
      margin: 8,
      fontFamily: "monospace",
      letterSpacing: "0.8px",
      color: "#29ADB2",
      fontWeight: "600",
      whiteSpace: "pre-wrap"
    });
  
    const TitleTypography = styled(Typography)({
      marginBottom: "10px",
      marginTop: "8px",
      fontSize: "26px",
      color: "rgb(32, 119, 190)"
    });
  
    return (
      <Container>
        <HeaderCard text={t("presentation.accessories.detail.description")} />
        <CustomCard>
          <TitleTypography>
            {t("presentation.accessories.detail.frames.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.accessories.detail.frames.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.accessories.detail.bearingsAndspacer.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.accessories.detail.bearingsAndspacer.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.accessories.detail.linersCuffAndstraps.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.accessories.detail.linersCuffAndstraps.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.accessories.detail.others.title")}
          </TitleTypography>
          <CustomTypography >
            {t("presentation.accessories.detail.others.description")}
          </CustomTypography>
        </CustomCard>
        <CustomCard>
          <TitleTypography>
            {t("presentation.accessories.detail.tip.title")}
          </TitleTypography>
          <CustomTypography>
            {t("presentation.accessories.detail.tip.description")}
          </CustomTypography>
        </CustomCard>
        <Card elevation={6} style={{width: "100%"}}>
        <CardMedia
          sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
          component="img"
          title={"accessory guide"}
          height={"600vw"}
          image={AccessoryDetails}
        />
        </Card>
      </Container>
    );
  };
  
  export default AccessoriessGuide;